<app-dialog
  headerText="Initial App Setup: Completed"
  [body]="body"
  [showCancelButton]="true"
  cancelText="Close"
  [showSaveButton]="false"
  [showTopCancelButton]="false"
  (cancel)="onClose()"
></app-dialog>

<ng-template #body>
  <div class="margin-bottom">
    The initial setup for app '{{ appDisplayName }}' was successful in the
    current Unified Services landscape.
  </div>
  <div>Resources were generated in {{ rootPath }}:</div>
  <ul>
    <li>
      <div class="resource-container">
        <div class="text">
          <span class="max-lines">{{ payload.baseFolderName }}</span>
          <span>(Folder)</span>
          <span
            fd-object-status
            status="positive"
            class="resource-state"
            title="Resource created successfully"
          >
            <app-icon icon="check"></app-icon>
          </span>
        </div>
      </div>
      <ul>
        <li>
          <div class="resource-container">
            <div class="text">
              <span class="max-lines">{{ payload.testFolderName }}</span>
              <span>(Folder)</span>
              <span
                fd-object-status
                status="positive"
                class="resource-state"
                title="Resource created successfully"
              >
                <app-icon icon="check"></app-icon>
              </span>
            </div>
          </div>
          <ul>
            <li>
              <div class="resource-container">
                <div class="text">
                  <span class="max-lines">{{
                    payload.testResourceGroupName
                  }}</span>
                  <span>(ResourceGroup)</span>
                  <span
                    fd-object-status
                    status="positive"
                    class="resource-state"
                    title="Resource created successfully"
                  >
                    <app-icon icon="check"></app-icon>
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <div class="resource-container">
            <div class="text">
              <span class="max-lines">{{ payload.resourceGroupName }}</span>
              <span>(ResourceGroup)</span>
              <span
                fd-object-status
                status="positive"
                class="resource-state"
                title="Resource created successfully"
              >
                <app-icon icon="check"></app-icon>
              </span>
            </div>
          </div>
          <ul>
            <li>
              <div class="resource-container">
                <div class="text">
                  <span class="max-lines">{{
                    payload.resourceTypeDefinition.name
                  }}</span>
                  <span>(ResourceTypeDefinition)</span>
                  <span
                    fd-object-status
                    status="positive"
                    class="resource-state"
                    title="Resource created successfully"
                  >
                    <app-icon icon="check"></app-icon>
                  </span>
                </div>
              </div>
            </li>
            @if (!!payload.automationSolution) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.automationSolution.name
                    }}</span>
                    <span>(AutomationSolution)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <div class="next-steps-container">
                    @if (numberOfParameterIssues > 0) {
                      <app-help-popover
                        headerTitle="Parameter Issues in AutomationSolution"
                        style="display: inline-grid"
                        [linkText]="
                          'Parameter Issues ' +
                          '(' +
                          numberOfParameterIssues +
                          ')'
                        "
                        [body]="parametersIssue"
                        icon="exclamation-triangle"
                        [linkIconEnabled]="true"
                        [linkEmphasized]="false"
                        placement="bottom"
                      ></app-help-popover>
                      <span class="separator">|</span>
                      <ng-template #parametersIssue>
                        We've detected some issues ({{
                          numberOfParameterIssues
                        }}) when adding parameters of service instance and/or
                        subscription to the generated AutomationSolution
                        resource for the consumer test subaccount. <br /><br />
                        To view the issues, please make sure you select the
                        option to download the PDF report before you close the
                        wizard. <br /><br />
                        It's important to download the PDF as these issues won't
                        be listed anywhere after you close the wizard, and it is
                        critical to address these issues afterwards in the
                        generated AutomationSolution using the Cloud Automation
                        Designer.
                      </ng-template>
                    }
                    <app-help-popover
                      headerTitle="Next Steps for AutomationSolution"
                      linkText="Next Steps"
                      [body]="automationSolution"
                      [linkEmphasized]="false"
                      placement="bottom"
                    ></app-help-popover>
                    <ng-template #automationSolution>
                      @if (!!templateSubaccount) {
                        We've created an AutomationSolution resource for your
                        app. <br /><br />
                        This resource contains a provisioning script to automate
                        the setup of your app for customers in SAP BTP based on
                        the resources in the selected consumer test subaccount.
                        <br /><br />
                        Go to the
                        <a
                          [href]="cloudAutomationDesignerUrl"
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >Cloud Automation Designer</a
                        >
                        to review and adjust the automation script, as needed.
                        For more information, see
                        <a
                          [href]="
                            !!payload.spfiApplication
                              ? 'https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-saas-app/#112-create-and-register-your-automation-solution-using-cloud-automation-designer-cad'
                              : 'https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-btp-paas-application/#2-create-and-register-your-automation-solution-using-cloud-automation-designer-cad'
                          "
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >documentation</a
                        >.
                      } @else {
                        We've created an AutomationSolution resource for your
                        app. <br /><br />
                        This resource contains a placeholder for your automation
                        script to automate the setup of your app for customers
                        in SAP BTP. <br /><br />
                        Go to the
                        <a
                          [href]="cloudAutomationDesignerUrl"
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >Cloud Automation Designer</a
                        >
                        to build your automation script. For more information,
                        see
                        <a
                          [href]="
                            !!payload.spfiApplication
                              ? 'https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-saas-app/#112-create-and-register-your-automation-solution-using-cloud-automation-designer-cad'
                              : 'https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-btp-paas-application/#2-create-and-register-your-automation-solution-using-cloud-automation-designer-cad'
                          "
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >documentation</a
                        >.
                      }
                    </ng-template>
                  </div>
                </div>
              </li>
            }
            @if (!!payload.automationSolution) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">cloud-automation-secret</span>
                    <span>(Secret)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <app-help-popover
                    headerTitle="More Info for Secret"
                    [body]="secret"
                    placement="bottom"
                  ></app-help-popover>
                  <ng-template #secret>
                    We've created a Secret resource for your Cloud Automation
                    credentials. <br /><br />
                    These credentials are retrieved from the instance and
                    binding of the SAP Cloud Management (cis) service's
                    'cloud-automation' plan created in the selected provider
                    subaccount that you selected. <br /><br />
                    The Secret is specified in your AutomationSolution.
                  </ng-template>
                </div>
              </li>
            }
            @if (!!payload.spfiApplication) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.spfiApplication.name
                    }}</span>
                    <span>(SPFIApplication)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <div>
                    <app-help-popover
                      [headerTitle]="
                        isDownloadSectionVisible
                          ? 'More Info for SPFIApplication'
                          : 'Next Steps for SPFIApplication'
                      "
                      [linkText]="
                        isDownloadSectionVisible ? undefined : 'Next Steps'
                      "
                      [linkEmphasized]="false"
                      [body]="
                        isBTPApplication === IsBTPApplication.YES
                          ? spfiNextStepsBTP
                          : spfiNextStepsNonBTP
                      "
                      placement="bottom"
                    ></app-help-popover>
                    <ng-template #spfiNextStepsBTP>
                      @if (scenario === OperationalScenario.UCA_SPFI) {
                        We've created an SPFIApplication resource for your app,
                        which is used for registration in Unified Provisioning.
                      } @else {
                        We've created an SPFIApplication resource for your app.
                        <br /><br />
                        The resource contains fake values in
                        <i>trustDetails</i> and <i>endpointUrl</i>, which you
                        need to replace with real values when your app
                        implementation is ready. <br /><br />
                        Go to the
                        <a
                          href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-saas-app/#12-implement-spfi-apis-on-your-own"
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >documentation</a
                        >
                        to learn how to implement SPFI, and to the
                        <a
                          href="https://api.sap.com/package/SAPCloudPlatformCoreServices"
                          [emphasized]="true"
                          target="_blank"
                          fd-link
                          >SAP Business Accelerator Hub</a
                        >
                        for information about using the SAP BTP core service
                        APIs to automate the setup of your app.
                      }
                    </ng-template>
                    <ng-template #spfiNextStepsNonBTP>
                      We've created an SPFIApplication resource for your app.
                      <br /><br />
                      The resource contains fake values in
                      <i>trustDetails</i> and <i>endpointUrl</i>, which you need
                      to replace with real values when your app implementation
                      is ready.
                    </ng-template>
                  </div>
                </div>
              </li>
            }
            @if (!!payload.managedApplicationProvider) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.managedApplicationProvider.name
                    }}</span>
                    <span>(ManagedApplicationProvider)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <div>
                    <app-help-popover
                      headerTitle="Next Steps for ManagedApplicationProvider"
                      linkText="Next Steps"
                      [body]="managedApplicationProvider"
                      [linkEmphasized]="false"
                      placement="bottom"
                    ></app-help-popover>
                    <ng-template #managedApplicationProvider>
                      We've created a ManagedApplicationProvider resource for
                      your app. The integration configuration in this resource
                      is currently empty.
                      @if (!Utils.isPrivateCloud) {
                        <div>
                          Go to the
                          <a
                            href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/integrate-your-app/"
                            [emphasized]="true"
                            target="_blank"
                            fd-link
                            >documentation</a
                          >
                          to learn how to configure this resource.
                        </div>
                      }
                    </ng-template>
                  </div>
                </div>
              </li>
            }
            @if (!!payload.integrations) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.integrations.name
                    }}</span>
                    <span>(Integrations)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                </div>
              </li>
            }
            @if (!!payload.cldTenantSyncEnablement) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.cldTenantSyncEnablement.name
                    }}</span>
                    <span>(CLDTenantSyncEnablement)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <app-help-popover
                    headerTitle="More Info for CLDTenantSyncEnablement"
                    [body]="CLDTenantSyncEnablement"
                    placement="bottom"
                  ></app-help-popover>
                  <ng-template #CLDTenantSyncEnablement>
                    We've created a CLDTenantSyncEnablement resource for your
                    app. <br /><br />
                    The CLDTenantSyncEnablement resource ensures that your
                    application’s tenants are automatically reported to the
                    Cloud Landscape Directory (CLD).
                  </ng-template>
                </div>
              </li>
            }
            @if (!!payload.account) {
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{ payload.account.name }}</span>
                    <span>(Account)</span>
                    <span
                      fd-object-status
                      status="positive"
                      class="resource-state"
                      title="Resource created successfully"
                    >
                      <app-icon icon="check"></app-icon>
                    </span>
                  </div>
                  <div>
                    <app-help-popover
                      headerTitle="Next Steps for Account"
                      linkText="Next Steps"
                      [body]="account"
                      [linkEmphasized]="false"
                      placement="bottom"
                    ></app-help-popover>
                    <ng-template #account>
                      We've created a Metering Account resource with the
                      specified local tenant type for your app. <br /><br />
                      Before you can start reporting usage for your app, the
                      Metering operations team must approve your Metering
                      Account resource. This resource will only reach the Ready
                      state once it is approved. For more information about the
                      approval process and support information, see
                      <a
                        href="https://pages.github.tools.sap/metering/documentation/docs/unified-metering/security-aspects/data-level-authorization/"
                        [emphasized]="true"
                        target="_blank"
                        fd-link
                        >Data Level Authorization</a
                      >.
                    </ng-template>
                  </div>
                </div>
              </li>
            }
          </ul>
        </li>
        <li>
          <div class="resource-container">
            <div class="text">
              <span class="max-lines">{{ payload.managedServiceName }}</span>
              <span>(ManagedService)</span>
              <span
                fd-object-status
                status="positive"
                class="resource-state"
                title="Resource created successfully"
              >
                <app-icon icon="check"></app-icon>
              </span>
            </div>
            <div>
              <app-help-popover
                headerTitle="More Info for ManagedService"
                [body]="managedService"
                placement="bottom"
              ></app-help-popover>
              <ng-template #managedService>
                We've created a ManagedService resource for your app.
                <br /><br />
                The new ManagedService '{{ payload.managedServiceName }}'
                contains all the references to the generated resources.
                <br /><br />
                Go to the
                <a
                  href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/product-concepts/managed-service/#managed-service-resource"
                  [emphasized]="true"
                  target="_blank"
                  fd-link
                  >documentation</a
                >
                to learn more about this resource.
              </ng-template>
            </div>
          </div>
        </li>
        <li>
          <div class="resource-container">
            <div class="text">
              <span class="max-lines">{{
                payload.servicePublishConfiguration.name
              }}</span>
              <span>(ServicePublishConfiguration)</span>
              <span
                fd-object-status
                status="positive"
                class="resource-state"
                title="Resource created successfully"
              >
                <app-icon icon="check"></app-icon>
              </span>
            </div>
            <div>
              <app-help-popover
                headerTitle="More Info for ServicePublishConfiguration"
                [body]="servicePublishConfiguration"
                placement="bottom"
              ></app-help-popover>
              <ng-template #servicePublishConfiguration>
                We've created a ServicePublishConfiguration resource for your
                app. <br /><br />
                The ServicePublishConfiguration resource publishes your resource
                type for testing purposes and is enabled recursively in the
                generated folder '{{ testFolderName }}'. <br /><br />
                This means that you and authorized users can instantiate your
                new resource type in any resource group that resides in the '{{
                  testFolderName
                }}' path.
              </ng-template>
            </div>
          </div>
        </li>
        <li>
          <div class="resource-container">
            <div class="text">
              <span class="max-lines">{{ payload.serviceMetadata.name }}</span>
              <span>(ServiceMetadata)</span>
              <span
                fd-object-status
                status="positive"
                class="resource-state"
                title="Resource created successfully"
              >
                <app-icon icon="check"></app-icon>
              </span>
            </div>
            <div>
              <app-help-popover
                headerTitle="More Info for ServiceMetadata"
                [body]="serviceMetadata"
                placement="bottom"
              ></app-help-popover>
              <ng-template #serviceMetadata>
                We've created a ServiceMetadata resource for your app.
                <br /><br />
                You may be required at a later stage to update the resource with
                additional information during the commercialization of your app.
              </ng-template>
            </div>
          </div>
        </li>
      </ul>
    </li>
  </ul>

  @if (isDownloadSectionVisible) {
    <div class="margin-top">
      <div class="testing-wrapper">
        <span
          ><strong>Want to learn how to test your provision flow?</strong></span
        >
        <app-help-popover
          i18n-linkText="
            XLNK|Creation Finished Dialog how to test
            link@@organizations.unified-creation-finished-dialog.howToTestLink"
          [linkEmphasized]="false"
          linkText="Click here"
          width="45rem"
          headerTitle="How to Test the Provisioning Flow"
          linkTooltip="Show instructions for testing the provisioning flow"
          [body]="howToTest"
        ></app-help-popover>
      </div>
      <ng-template
        i18n="
          XMSG|How to test
          text@@organizations.unified-creation-finished-dialog.howToTestBodyText"
        #howToTest
      >
        You can already execute your first level-0 test of the provisioning flow
        for your app:
        <ol>
          <li>
            Download this
            <a
              fd-link
              aria-label="Standard"
              href="javascript:void(0)"
              (click)="downloadYamlFiles()"
              [emphasized]="true"
              >ZIP file</a
            >
            containing two YAML files and unzip it to your local drive:
            <ul>
              <li>
                <strong>level-0-app-tenant-instance.yaml</strong>: Represents an
                instance of your app's newly defined resource type.
              </li>
              <li>
                <strong>level-0-fulfillment-data.yaml</strong>: Represents an
                instance of the FulfillmentData resource, which mimics the
                commercialization data of a consumer that would activate your
                app.
              </li>
            </ul>
            NOTE: You won't be able to download the YAML files after you close
            the wizard, so do it now.
          </li>
          <li>
            Update the placeholder fields and other relevant fields as needed in
            the level-0-fulfillment-data.yaml file.
          </li>
          <li>
            Review and adjust your AutomationSolution, as needed, in the Cloud
            Automation Designer (CAD) here in Unified Services Workspace. <br />
            @if (!!templateSubaccount) {
              NOTE: A provisioning script was created in the AutomationSolution,
              but you still need to update it (for example, to define the
              dependencies between modules).
            } @else {
              NOTE: You'll need to create the automation script for the
              provisioning flow in the AutomationSolution. If you want, you can
              use one of the ready-made templates that are available in CAD.
            }
          </li>
          <li>
            Once your AutomationSolution contains the provisioning script, apply
            the two YAML files in the 'test-resources' resource group that has
            been generated for you (full path: {{ testResourceGroupPath }}). You
            can use the <strong>Create with YAML</strong> action in the
            <strong>New</strong> menu to apply the YAML files.
          </li>
        </ol>
        <strong>Result:</strong> <br /><br />
        A request to provision your app is triggered, which executes the
        provisioning script defined in your AutomationSolution. If the test is
        successful, a consumer subaccount containing all the relevant resources
        and configurations is created in your provider global account.
      </ng-template>
    </div>
  }
  @if (isOpenInCadVisible || numberOfParameterIssues) {
    <div class="checkbox-wrapper">
      @if (isOpenInCadVisible) {
        <fd-checkbox
          label="Open in Cloud Automation Designer"
          [(ngModel)]="openInCad"
          [fdCompact]="true"
          inputId="openInCadCheckbox"
          title="Opens the AutomationSolution in the Cloud Automation Designer tool after you close the wizard"
        ></fd-checkbox>
      }
      @if (numberOfParameterIssues) {
        <fd-checkbox
          label="Download PDF report of AutomationSolution parameter issues"
          [(ngModel)]="downloadReport"
          (change)="onDownloadReportChange()"
          [fdCompact]="true"
          inputId="downloadReportCheckbox"
          title="After you close the wizard, downloads a PDF report containing parameter issues"
        ></fd-checkbox>
      }
    </div>
  }

  <div class="margin-top">
    <span
      >TIP: Import your project into <strong>URM Studio</strong> to
      automatically convert it to Helm-based format and unlock additional
      benefits.
      <a
        href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-saas-app-urm/#recommended-import-your-project-to-urm-studio"
        target="_blank"
        fd-link
        >Go to documentation</a
      >
    </span>
  </div>
</ng-template>
